import { render, staticRenderFns } from "./ImprintView.vue?vue&type=template&id=33b72ef5&scoped=true"
import script from "./ImprintView.vue?vue&type=script&lang=js"
export * from "./ImprintView.vue?vue&type=script&lang=js"
import style0 from "./ImprintView.vue?vue&type=style&index=0&id=33b72ef5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b72ef5",
  null
  
)

export default component.exports